import { Api } from "../../common/js/api";
import EventsHelper from "../../common/js/eventsHelper";

export class ProductItem {
    constructor() {

        this.item = '.fs-product-item';
        this.favoriteIcon = '.fs-product-item--icon.fs--favorite';
        this.addIcon = '.fs-product-item--icon.fs--cart';
        this.inCartLabel = '.fs-product-item--in-cart';

        this.classFavorite = 'fs--favorite-add';
        this.classAdded = 'fs--added';
        this.classShow = 'fs--show';
        this.assetsPath = '/themes/fashiong/assets/img';

        this.eventsHandler();
    }

    eventsHandler() {
        document.querySelectorAll(this.favoriteIcon).forEach(icon => {
            icon.addEventListener('click', this.handleOnFavoriteIconClick)
        })

        document.querySelectorAll(this.addIcon).forEach(icon => {
            icon.addEventListener('click', this.handleOnAddIconClick)
        })
    }

    handleOnAddIconClick = e => {
        const icon = e.currentTarget;
        const item = icon.closest(this.item);
        const label = item.querySelector(this.inCartLabel);      
        
        Api.addProductToCart(this.collectProductData(item));
        EventsHelper.onAddToCart();
        icon.classList.add(this.classAdded);
        label.classList.add(this.classShow);
    }

    collectProductData(item) {
        const product_id = item.getAttribute('data-product-id');
        const product_total_price = item.getAttribute('data-product-price');
        const productOldPrice = item.getAttribute('data-product-old-price');
        const old_price = productOldPrice == product_total_price ? null : productOldPrice;

        return {
            product_id,
            product_quantity: '1.0',
            product_total_price,
            old_price,
        }
    }

    handleOnFavoriteIconClick = e => {
        const icon = e.currentTarget;
        const productId = icon.closest(this.item).getAttribute('data-product-id');

        icon.classList.contains(this.classFavorite)
            ? this.removeFromFavorite(icon, productId)
            : this.addToFavorite(icon, productId);
    }

    removeFromFavorite(icon, productId) {
        icon.src = `${this.assetsPath}/icon-heart.svg`;
        icon.classList.remove(this.classFavorite);

        Api.removeProductFromFavorite(productId);
        EventsHelper.onRemoveFromFavorite();
    }

    addToFavorite(icon, productId) {
        icon.classList.add(this.classFavorite);
        icon.src = `${this.assetsPath}/icon-heart-active.svg`;

        Api.addProductToFavorite(productId);
        EventsHelper.onAddToFavorite();
    }

    addToCart(icon, productId) {
        const data = {
            productId,
            product_quantity: '1.0',
            product_total_price: '',
            old_price: null,
        }

        Api.addProductToCart(data);
        EventsHelper.onAddToCart();
    }
}